/* Geurvinder: <geur-vinder> custom element. Needs geurvinder-engine.js, geurvinder-match.js, geurvinder-ui.js,
   geurvinder-view.js. The reference perfume list (geurvinder-ref.js, -ref-2.js) is loaded on the first search. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('geur-vinder')) return;
  var E = window.GeurvinderEngine, U = window.GeurvinderUI;
  var esc = U.esc, moneyFmt = U.moneyFmt, liveAdapter = U.liveAdapter, buildSteps = U.buildSteps;

  class GeurVinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var cfgEl = this.querySelector('script[data-gv-config]');
      try { this.cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { this.cfg = {}; }
      this.cfg.pools = this.cfg.pools || {};
      this.cfg.root = this.cfg.root || '/';
      this.T = this.cfg.t = U.decode(this.cfg.t || window.GeurvinderText);
      this.adapter = window.GeurvinderAdapter || liveAdapter;
      this.money = moneyFmt(this.cfg);
      this.stage = this.querySelector('[data-gv-stage]');
      this.profile = this.querySelector('[data-gv-profile]');
      this.live = this.querySelector('[data-gv-live]');
      this.likeForm = this.querySelector('[data-gv-like]');
      this.reset();
      this.addEventListener('click', this.onClick.bind(this));
      if (this.likeForm) {
        this.likeForm.addEventListener('submit', this.onLike.bind(this));
        this.likeForm.addEventListener('focusin', this.ensureRef.bind(this), { once: true });
      }
      this.renderStage(false);
    }

    reset() {
      this.A = { fams: [] };
      this.stepIndex = 0;
      this.mode = 'quiz';
      this.page = 1;
      this.rebuildSteps();
      this.classList.remove('is-started');
      if (this.likeForm) this.likeForm.reset();
    }
    rebuildSteps() { this.steps = buildSteps(this.cfg, this.money, !!this.A.gift, this.A.gender); }

    // ---------- data ----------
    ensurePool() {
      if (this.poolPromise) return this.poolPromise;
      var self = this, c = this.cfg;
      var urls = c.current ? [c.current] : [c.pools.spray].concat(c.askForm && c.pools.olie ? [c.pools.olie] : []);
      urls = urls.filter(Boolean).map(function (u) { return U.base(u, c.root); });
      this.poolPromise = Promise.all(urls.map(function (u) {
        return self.adapter.load(u, c).catch(function () { return null; });
      })).then(function (lists) {
        var all = [], okCount = 0;
        lists.forEach(function (l) { if (l) { okCount++; all = all.concat(E.prepareAll(l)); } });
        if (!okCount) throw new Error('Geurvinder: geen data');
        self.poolSize = all.length;
        return all;
      });
      this.poolPromise.catch(function () { self.poolPromise = null; });
      return this.poolPromise;
    }
    // gift sets for the "Liever een cadeauset?" row; failures just hide the row
    ensureSets() {
      var c = this.cfg;
      if (!c.giftSets) return Promise.resolve([]);
      if (!this.setsPromise) {
        var self = this;
        this.setsPromise = this.adapter.load(U.base(c.giftSets, c.root), c).then(E.prepareSets).catch(function () { self.setsPromise = null; return []; });
      }
      return this.setsPromise;
    }
    ensureRef() {
      var urls = this.cfg.refUrls || [];
      return window.GeurvinderRef && !urls.length ? Promise.resolve() : Promise.all(urls.map(U.loadScript));
    }

    // ---------- events ----------
    onClick(e) {
      var t = e.target.closest('[data-gv-opt],[data-gv-back],[data-gv-next],[data-gv-restart],[data-gv-more],[data-gv-add],[data-gv-edit],[data-gv-retry],[data-gv-product],[data-gv-quiz],[data-gv-gift],[data-gv-unknown],[data-gv-set]');
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-gv-opt')) return this.pick(t.getAttribute('data-gv-opt'));
      if (t.hasAttribute('data-gv-gift')) return this.setGift(t.getAttribute('data-gv-gift') === '1');
      if (t.hasAttribute('data-gv-unknown')) { this.A.fams = []; this.A.famsUnknown = true; this.renderProfile(); return this.next(); }
      if (t.hasAttribute('data-gv-next')) return this.next();
      if (t.hasAttribute('data-gv-back')) return this.back();
      if (t.hasAttribute('data-gv-edit')) return this.goTo(Number(t.getAttribute('data-gv-edit')));
      if (t.hasAttribute('data-gv-restart')) { this.reset(); this.renderProfile(); return this.renderStage(true); }
      if (t.hasAttribute('data-gv-quiz')) { delete this.A.mode; delete this.A.like; if (this.likeForm) this.likeForm.reset(); return this.goTo(this.firstOpen()); }
      if (t.hasAttribute('data-gv-more')) {
        var self = this, per = this.cfg.results || 3;
        this.page++;
        return this.localize((this.results || []).slice(0, per * this.page)).then(function () { self.renderResults(true); });
      }
      if (t.hasAttribute('data-gv-retry')) return this.showResults();
      if (t.hasAttribute('data-gv-add')) { e.preventDefault(); return this.add(t); }
      if (t.hasAttribute('data-gv-product')) {
        var r = this.results && this.results[Number(t.getAttribute('data-gv-product'))];
        if (r) this.adapter.track('geurvinder_klik', { product: r.P.raw.u, positie: Number(t.getAttribute('data-gv-product')) + 1, match: r.pct, cadeau: !!this.A.gift });
      }
      if (t.hasAttribute('data-gv-set')) {
        var s = this.sets && this.sets[Number(t.getAttribute('data-gv-set'))];
        if (s) this.adapter.track('geurvinder_klik', { product: s.P.raw.u, positie: Number(t.getAttribute('data-gv-set')) + 1, cadeauset: true, cadeau: true });
      }
    }

    onLike(e) {
      e.preventDefault();
      var input = this.likeForm.querySelector('input');
      var q = (input && input.value || '').trim();
      if (q.length < 2) { if (input) input.focus(); return; }
      if (this.quizDone() && this.A.mode !== 'like') this.A.like = q;
      else { this.A.mode = 'like'; this.A.like = q; }
      this.adapter.track('geurvinder_lijkt_op', { zoekterm: q });
      this.showResults();
    }

    setGift(on) {
      if (!!this.A.gift === on) return;
      this.A.gift = on;
      this.rebuildSteps();
      this.ensurePool();
      if (on) this.ensureSets();
      this.renderProfile();
      this.renderStage(false);
      var b = this.stage.querySelector('[data-gv-gift="' + (on ? 1 : 0) + '"]');
      if (b) b.focus();
      if (this.live) this.live.textContent = on ? this.T.live_gift : this.T.live_self;
    }

    pick(v) {
      var step = this.steps[this.stepIndex];
      this.classList.add('is-started');
      this.ensurePool();
      if (step.multi) {
        var arr = this.A.fams.slice(), i = arr.indexOf(v);
        if (i >= 0) arr.splice(i, 1);
        else { if (arr.length >= step.multi) arr.shift(); arr.push(v); }
        this.A.fams = arr;
        this.A.famsUnknown = false;
        this.renderProfile();
        this.stage.querySelectorAll('[data-gv-opt]').forEach(function (b) {
          b.setAttribute('aria-pressed', arr.indexOf(b.getAttribute('data-gv-opt')) >= 0 ? 'true' : 'false');
        });
        var nx = this.stage.querySelector('[data-gv-next]');
        if (nx) nx.disabled = !arr.length;
        return;
      }
      this.A[step.id] = v;
      if (step.id === 'gender' && this.A.gift) this.rebuildSteps();
      this.renderProfile();
      this.stage.querySelectorAll('[data-gv-opt]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-gv-opt') === v ? 'true' : 'false');
      });
      var self = this;
      clearTimeout(this._t);
      this._t = setTimeout(function () { self.next(); }, 200);
    }

    next() {
      // editing one answer from the profile: go straight back to the results
      if (this._editing && this.quizDone()) { this._editing = false; return this.showResults(); }
      if (this.stepIndex < this.steps.length - 1) { this.stepIndex++; this.renderStage(true); }
      else this.showResults();
    }
    back() {
      if (this.mode === 'results') { this.mode = 'quiz'; delete this.A.mode; this.stepIndex = this.steps.length - 1; }
      else if (this.stepIndex > 0) this.stepIndex--;
      this.renderProfile();
      this.renderStage(true);
    }
    goTo(i) {
      this._editing = this.quizDone();
      this.mode = 'quiz';
      this.stepIndex = Math.max(0, Math.min(i, this.steps.length - 1));
      this.renderProfile();
      this.renderStage(true);
    }
    firstOpen() {
      for (var i = 0; i < this.steps.length; i++) if (!this.answerLabel(this.steps[i])) return i;
      return 0;
    }
    quizDone() { return this.firstOpen() === 0 && !!this.answerLabel(this.steps[0]); }

    answerLabel(s) {
      var A = this.A;
      if (s.multi) {
        if (!A.fams.length && A.famsUnknown) return this.T.unknown;
        return A.fams.map(function (v) {
          var o = s.options.filter(function (x) { return x.v === v; })[0];
          return o ? o.l : '';
        }).join(' + ');
      }
      var v = A[s.id];
      var o = s.options.filter(function (x) { return x.v === v; })[0];
      if (!o) return '';
      if (s.id === 'gender' && A.gift) return v === 'him' ? this.T.a_gift_him : v === 'her' ? this.T.a_gift_her : this.T.a_gift;
      return o.l;
    }

    // Visitors on /de/, /en/, ...: fetch the translated title, link and notes of the products about to be shown.
    // Matching itself always runs on the default-language data. Gives up after 3 s and shows what it has.
    localize(list) {
      var self = this, c = this.cfg;
      var todo = (list || []).map(function (r) { return r.P; }).filter(function (P) { return P && P.loc === undefined; });
      if (c.root === '/' || !todo.length || !this.adapter.details) return Promise.resolve();
      var all = Promise.all(todo.map(function (P) {
        return self.adapter.details(P.raw.u, c).then(function (d) { P.loc = d || null; });
      }));
      return Promise.race([all, new Promise(function (res) { setTimeout(res, 3000); })]);
    }

    showResults() {
      var self = this, A = this.A, c = this.cfg, T = this.T;
      this.mode = 'results';
      this.page = 1;
      this.classList.add('is-started');
      this.renderProfile();
      var per = c.results || 3, sk = '';
      for (var k = 0; k < per; k++) sk += '<div class="gv-skel"></div>';
      this.stage.innerHTML = '<div class="gv-res" aria-busy="true"><p class="gv-res__eyebrow">' + esc(T.loading) + '</p><div class="gv-grid">' + sk + '</div></div>';
      Promise.all([
        this.ensurePool(),
        A.like ? this.ensureRef() : null,
        A.gift ? this.ensureSets() : null
      ]).then(function (got) {
        var opts = { budgetLow: c.budgetLow, budgetHigh: c.budgetHigh, perPage: per, max: per * 3 };
        var M = A.like ? E.makeMatcher(A.like, window.GeurvinderRef) : null;
        self.matcher = M;
        opts.matcher = M;
        self.results = E.annotate(E.rank(got[0], A, opts), A, M);
        self.sets = A.gift && got[2] && got[2].length ? E.rankSets(got[2], A, self.results, opts) : null;
        return self.localize(self.results.slice(0, per).concat(self.sets || [])).then(function () { return M; });
      }).then(function (M) {
        self.renderResults(false);
        self.adapter.track('geurvinder_resultaat', {
          antwoorden: { voor: A.gender || '', geur: A.famsUnknown ? 'weet ik niet' : A.fams.join(','), moment: A.moment || '', vorm: A.form || '', budget: A.budget || '', lijkt_op: A.like || '' },
          cadeau: !!A.gift,
          referentie: M && M.R ? M.R.n : '',
          producten: self.results.slice(0, per).map(function (r) { return r.P.raw.u; })
        });
      }).catch(function () {
        var url = c.current || c.pools.spray || U.local('/collections/all', c.root);
        self.stage.innerHTML = '<div class="gv-res gv-enter"><h3 class="gv-res__title" tabindex="-1">' + esc(T.err_title) + '</h3>' +
          '<p class="gv-res__sub">' + esc(T.err_text) + '</p>' +
          '<div class="gv-res__actions"><button type="button" class="gv-btn" data-gv-retry>' + esc(T.retry) + '</button>' +
          '<a class="gv-btn gv-btn--ghost" href="' + esc(url) + '">' + esc(T.all) + '</a></div></div>';
        self.focusTitle('.gv-res__title');
      });
    }
  }

  Object.keys(U.view).forEach(function (k) { GeurVinder.prototype[k] = U.view[k]; });
  customElements.define('geur-vinder', GeurVinder);
})();